import { browserHistory } from 'react-router'

import { getProductTypes } from 'reduxpath/ducks/ProductType/List'
import { getProductTypeById } from 'reduxpath/ducks/ProductType/Edit'
import { removeProductType } from 'reduxpath/ducks/ProductType/Remove'

import Home from 'units/ProductType'
import List from 'units/ProductType/units/List'
import Add from 'units/ProductType/units/Add'
import Edit from 'units/ProductType/units/Edit'

const list = (store) => {
  store.dispatch(
    getProductTypes({
      sort: 'createdAt ASC',
      limit: 10,
      skip: 0,
    }),
  )
}

const edit = (store, id) => {
  store.dispatch(
    getProductTypeById(id),
  )
}

const remove = (store, id) => {
  store.dispatch(
    removeProductType(id, () => {
      browserHistory.push('/product_types')
    }),
  )
}

export default {
  populate: {
    list,
    edit,
    remove,
  },
  components: {
    Home,
    List,
    Add,
    Edit,
  },
}
